import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_GCP_CLOUD_RUN,
  GET_GCP_CLOUD_RUN_SUCCESS,
  GET_GCP_CLOUD_RUN_ERROR,
} from "./constant";

import { getGCPCloudRunApi } from "./api";

function* getGCPCloudRunList(params) {
  try {
    const data = yield call(getGCPCloudRunApi, params);
    yield put({ type: GET_GCP_CLOUD_RUN_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_GCP_CLOUD_RUN_ERROR, error });
  }
}

export function* manageGCPCloudRunSaga() {
  yield takeLatest(GET_GCP_CLOUD_RUN, getGCPCloudRunList);
}
